<div class="row fuelux">
	<div class="col-lg-12">
		<div class="main-box clearfix">
			<div class="main-box-body clearfix wizardmainbox">
				<div class="wizard" data-initialize="wizard" id="uploadResumesWizard">
					<div class="steps-container">
						<ul class="steps">
							<li data-step="1" data-name="upload" class="active">
								<span class="badge">1</span>Upload<span class="chevron"></span>
							</li>
							<li data-step="2" data-name="scoring" *ngIf="!isSingleCandidateUpload">
								<span class="badge">2</span>
								<span *ngIf="jobContextExistsFlag">Review</span>
								<span *ngIf="!jobContextExistsFlag">View Results</span>
								<span class="chevron"></span>
							</li>
						</ul>
					</div>
					<div class="actions" *ngIf="!isSingleCandidateUpload">
						<button type="button" class="btn btn-info btn-prev" [disabled]="disablePreviousButtonFlag">
							<span class="glyphicon glyphicon-arrow-left"></span>Prev
						</button>
						<button type="button" class="btn btn-info btn-next" data-last="Complete" [disabled]="disableNextButtonFlag">
							Next<span class="glyphicon glyphicon-arrow-right"></span>
						</button>
					</div>
					<div class="step-content">
						<div class="step-pane active" data-step="1">
							<div class="row">
								<div class="col-lg-12">
									<div class="main-box clearfix" style="min-height: 200px;">
										<div class="row">
											<div class="col-lg-5 col-lg-offset-1" style="margin-top: 2%; padding: 0 20px 20px 20px;">
												<form role="form" #uploadResumesForm="ngForm" novalidate>
													<div class="form-group">
														<label for="sourceType" class="control-label">
															{{MESSAGECONSTANTS.LABLES.UPLOAD_RESUME.SOURCE_TYPE}}
															<em> * </em> :
														</label>
														<select class="form-control" name="sourceType" id="sourceType"
																[(ngModel)]="sourceType" (ngModelChange)="sourceTypeChanged()" [disabled]="disableSourceTypesFlag" required>
															<option *ngFor="let source of sourceTypeList" [ngValue]="source">{{source.sourceType}}</option>
														</select>
													</div>
													<div class="form-group" *ngIf="sourceType?.sourceType == 'Other'">
														<label for="otherSourceTypeNotes" class="control-label">
															Notes<em> * </em> :
														</label>
														<!-- Voice Input -->
														<div class="mb-2">
															<app-voice-input
																(transcriptReady)="onVoiceTranscript($event)"
																[candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
																[company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
																[requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
																[jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null"
																[sourceScreen]="sourceScreen">
															</app-voice-input>
														</div>
														<textarea class="form-control" name="otherSourceTypeNotes" id="otherSourceTypeNotes" maxlength="503"
																  [(ngModel)]="otherSourceTypeNotes" required [disabled]="disableSourceTypesFlag"></textarea>
														<!-- Formalize Text -->
														<app-formalize-comment
															[inputText]="otherSourceTypeNotes"
															(outputText)="receiveFormalizedComment($event)"
															[candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
															[company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
															[requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
															[jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null"
															[sourceScreen]="sourceScreen">
														</app-formalize-comment>
													</div>
													<div class="form-group" *ngIf="sourceType?.sourceType == 'Referral'">
														<label for="referrerName" class="control-label">
															Referrer Name<em> * </em> :
														</label>
														<input type="text" class="form-control" name="referrerName" id="referrerName" [(ngModel)]="referrerName" required [disabled]="disableSourceTypesFlag">
													</div>
													<div class="form-group" *ngIf="sourceType?.sourceType == 'Referral'">
														<label for="referrerEmail" class="control-label">
															Referrer Email<em> * </em> :
														</label>
														<input type="email" name="referrerEmail" id="referrerEmail" class="form-control" placeholder="example@example.com"
															   [(ngModel)]="referrerEmail" [pattern]="MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL"
															   required [disabled]="disableSourceTypesFlag" #referrerEmailField="ngModel">
														<span class="help-block">ex. example@example.com</span>
														<small class="error" *ngIf="referrerEmailField.dirty && referrerEmailField.invalid">
															{{MESSAGECONSTANTS.COMMONVALIDATIONS.NOT_VALID_EMAIL}}
														</small>
													</div>
												</form>
											</div>
										</div>
										<div class="main-box-body clearfix col-lg-10 col-lg-offset-1">
											<div>
												<form name="resumeUploadDropzone" id="resumeUploadDropzone" class="dropzone dz-clickable" action="" enctype="multipart/form-data"
													[dropzone]="dropzoneConfig" (addedFile)="onFileAdded()" (removedFile)="onFileRemoved($event)"
													(sendingMultiple)="onFileSendingMultiple($event)" (successMultiple)="onFileSuccessMultiple($event)"
													(error)="onFileError($event)">
													<div class="dz-a dz-default dz-message">
														<span>
															<h3>Drop files here to upload</h3>(or click)
														</span>
													</div>
												</form>
											</div>
										</div>
										<!-- Upload Requisition button -->
										<div class="row buttonrow" style="margin-bottom: 200px">
											<div class="col-xs-12 col-sm-offset-4 col-sm-4">
												<button type="button" class="btn btn-success col-xs-12" id="uploadFile" (click)="uploadResumes(uploadResumesForm)" [disabled]="disableUploadButtonFlag">
													<i class="fa fa-upload mr-2"></i>
													<span *ngIf="!fileUploadInProgressFlag">Upload </span><span *ngIf="fileUploadInProgressFlag">Uploading... </span> Resume
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="step-pane" data-step="2">
							<!-- Multiple candidates resume upload -->
							<div class="row" [hidden]="isSingleCandidateUpload">
								<div class="col-xs-12">
									<div class="main-box clearfix" style="min-height: 180px;">
										<div class="row">
											<div class="col-xs-8">
												<div class="upload-resumes-counts-heading">Candidate Counts</div>
											</div>
										</div>
										<div class="row upload-resumes-counts-row" *ngIf="scoringCandidatesFlag || gettingCountsFlag">
											<div class="col-xs-4 col-xs-offset-4">
												<h4 style="border-bottom: none;">Processing <i class="fa fa-spin fa-spinner"></i></h4>
											</div>
										</div>
										<div class="row upload-resumes-counts-row" *ngIf="!scoringCandidatesFlag && !gettingCountsFlag">
											<div class="col-xs-offset-1 col-xs-3">
												<span>Uploaded Candidates :</span>
												<span class="pull-right">
													<a href="" *ngIf="!jobContextExistsFlag" tooltip="Click to view Uploaded Candidates." placement="top-right" container="body" (click)="displayCandidates('Uploaded')">{{totalUploads}}</a>
													<span *ngIf="jobContextExistsFlag">{{totalUploads}}</span>
												</span>
											</div>
											<div class="col-xs-offset-1 col-xs-3">
												<span>Resumes Not Processed :</span>
												<span class="pull-right">
													<span>{{candidateCount?.notProcessedCandidateCount}}</span>
												</span>
											</div>
										</div>
										<div class="row upload-resumes-counts-row" *ngIf="!scoringCandidatesFlag && !gettingCountsFlag">
											<div class="col-xs-offset-1 col-xs-3">
												<span>Matched Candidates :</span>
												<span class="pull-right">
													<a href="" tooltip="Click to view Matched Candidates." placement="top-right" container="body" *ngIf="!jobContextExistsFlag && candidateCount?.matchedCandidateCount > 0" (click)="displayCandidates('Matched')">{{candidateCount.matchedCandidateCount}}</a>
													<span *ngIf="jobContextExistsFlag || (candidateCount?.matchedCandidateCount == 0)">{{candidateCount?.matchedCandidateCount}}</span>
												</span>
											</div>
											<div class="col-xs-offset-1 col-xs-3">
												<span>Unmatched Candidates :</span>
												<span class="pull-right">
													<a href="" tooltip="Click to view Unmatched Candidates." placement="top-right" container="body" *ngIf="!jobContextExistsFlag && candidateCount?.unMatchedCandidateCount > 0" (click)="displayCandidates('UnMatched')">{{candidateCount.unMatchedCandidateCount}}</a>
													<span *ngIf="jobContextExistsFlag || (candidateCount?.unMatchedCandidateCount == 0)">{{candidateCount?.unMatchedCandidateCount}}</span>
												</span>
											</div>
										</div>
										<div class="row upload-resumes-counts-row" *ngIf="jobContextExistsFlag && !scoringCandidatesFlag && !gettingCountsFlag">
											<div class="col-xs-offset-1 col-xs-3">
												<span>Manually Matched Candidates :</span>
												<span class="pull-right">
													<span>{{candidateCount?.manuallyMatchedCandidateCount}}</span>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div class="col-xs-12" *ngIf="jobContextExistsFlag">
									<div class="main-box clearfix" style="height:400px;padding-top: 10px;position:relative">
										<div class="main-box-body clearfix">
											<div class="row" *ngIf="scoringCandidatesFlag">
												<div class="col-xs-12 no_candidates_found text-center">
													<span>Loading</span>
													<span class="fa fa-spinner fa-spin"></span>
												</div>
											</div>
											<div class="row" *ngIf="!scoringCandidatesFlag && displaySelectDeselectButtonFlag" style="margin-bottom: 15px;">
												<div class="col-xs-12 clearfix">
													<div class="pull-left">
														<button type="button" class="btn btn-info" (click)="toggleSelectAllCandidates()">
															<span *ngIf="!selectedAllCandidatesFlag">Select All</span>
															<span *ngIf="selectedAllCandidatesFlag">Deselect All</span>
														</button>
													</div>
												</div>
											</div>
											<div class="row" *ngIf="!scoringCandidatesFlag">
												<div class="col-xs-12">
													<div class="row" class="upload-resumes-review-table-header-row">
														<div class="col-xs-1 upload-resumes-review-table-header-text">
															Select
														</div>
														<div class="col-xs-2 upload-resumes-review-table-header-text">
															Name
														</div>
														<div class="col-xs-2 upload-resumes-review-table-header-text">
															Phone Number
														</div>
														<div class="col-xs-2 upload-resumes-review-table-header-text">
															Email
														</div>
														<div class="col-xs-1 upload-resumes-review-table-header-text">
															Score
														</div>
														<div class="col-xs-4 upload-resumes-review-table-header-text">
															Status
														</div>
													</div>
												</div>
											</div>
											<div class="row" *ngIf="!scoringCandidatesFlag" style="height:300px; overflow-y: auto">
												<div class="col-xs-12" *ngFor="let candidate of candidatesList">
													<div class="row upload-resumes-review-table-row" [ngClass]="{'upload-resumes-associate-candidate-selection-bg': candidate.selectedFlag, 'green-bg': candidate.candidateMatchedToJob}">
														<div class="col-xs-1 text-overflow-ellipsis" *ngIf="!candidate.showOverride">
															<div class="">
																<input type="checkbox" [(ngModel)]="candidate.selectedFlag"
																   [disabled]="!candidate.allowManualMatch"
																   (click)="candidateToAssociateToggle(candidate)"/>
															</div>
														</div>
														<div class="col-xs-1" *ngIf="candidate.showOverride">
															<button class="btn btn-primary" style="margin-left:-10px; position:relative; bottom:7px" (click)="showOverrideCandidateSuspensionModal(candidate)">Override</button>
														</div>
														<div class="col-xs-2 text-overflow-ellipsis" tooltip="{{candidate.name}}" placement="auto bottom" container="body">{{candidate.name}}
														</div>
														<div class="col-xs-2 text-overflow-ellipsis" tooltip="{{candidate.phone}}" placement="auto bottom" container="body">{{candidate.phone}}
														</div>
														<div class="col-xs-2 text-overflow-ellipsis" tooltip="{{candidate.email}}" placement="auto bottom" container="body">{{candidate.email}}
														</div>
														<div class="col-xs-1" (click)="jobCompare(candidate)">
															<span tooltip="Threshold Score: {{candidate.jobThresholdScore}}" class="cursor-pointer ml-2" placement="auto bottom-left" container="body"
																	[ngClass]="{'candidate-job-match-card-intelligence-score-success job-match-card-green-bg': candidate.intelligenceScorePassFlag,
																	'candidate-job-match-card-intelligence-score-failure': !candidate.intelligenceScorePassFlag}">
																	{{candidate.score}}
															</span>
														</div>
														<div class="col-xs-4 text-overflow-ellipsis" tooltip="{{candidate.statusOfJobMatch}}" placement="auto bottom-right" container="body">{{candidate.statusOfJobMatch}}
														</div>
													</div>
												</div>
											</div>
											<div class="row" [hidden]="isSingleCandidateUpload" style="position: absolute; bottom: 0; right: 0; margin: 5px;">
												<div class="col-xs-12 clearfix">
													<div class="pull-right">
														<button type="button" class="btn btn-success" (click)="associateCandidates()" [disabled]="(candidatesToAssociateList.length == 0) || associatingCandidatesFlag">
															<span *ngIf="!associatingCandidatesFlag">Add Selected Candidates</span>
															<span *ngIf="associatingCandidatesFlag">Adding Candidates ...</span>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Single candidate resume upload -->
							<div class="row" *ngIf="isSingleCandidateUpload">
								<div class="col-xs-12">
									<div class="main-box" style="min-height: 400px;">
										<div class="row" *ngIf="scoringCandidatesFlag">
											<div class="col-xs-12 no_candidates_found text-center">
												<span>Loading</span>
												<span class="fa fa-spinner fa-spin"></span>
											</div>
										</div>
										<div class="row" *ngIf="!scoringCandidatesFlag">
											<!-- Display table -->
											<div class="col-xs-12 mt-4 px-5" *ngIf="!showCandidateUpdateFailureMessage">
												<div [hidden]="!isDirectCandidateUpdate">
													<p>The existing contact details match the details in the resume.<p>
														<div *ngIf="candidateDetailsToUpdate?.additionalMatchRuleVerified">
															<p *ngIf="candidateDetailsToUpdate?.additionalMatchRuleVerificationPassed && candidatesList.length>0">
																Additional matching criteria of education and experience have been verified.
															</p>
															<p *ngIf="!candidateDetailsToUpdate?.additionalMatchRuleVerificationPassed && candidatesList.length>0">
																Additional matching criteria of education and/or experience do not match.
															</p>
														</div>
													<p>Candidate has been updated.</p>
												</div>

												<div [hidden]="isDirectCandidateUpdate">
													<div [hidden]="!candidateDetailsToUpdate?.additionalMatchRuleVerified">
														<p *ngIf="candidateDetailsToUpdate?.additionalMatchRuleVerificationPassed && candidatesList.length>0">
															Additional matching criteria of education and experience have been verified.
														</p>
														<p *ngIf="!candidateDetailsToUpdate?.additionalMatchRuleVerificationPassed && candidatesList.length>0" class="text-danger">
															Additional matching criteria of education and/or experience do not match.
														</p>
													</div>
													<p *ngIf="candidateDetailsToUpdate?.candidateUpdated && candidatesList.length>0">Candidate has been updated.</p>
													<p *ngIf="!candidateDetailsToUpdate?.candidateUpdated && candidatesList.length>0">Candidate Details Not Updated: </p>
												</div>
												<table class="table table-bordered table-responsive">
													<thead>
														<tr>
															<th>First Name</th>
															<th>Last Name</th>
															<th>Email</th>
															<th>Phone Number</th>
														</tr>
													</thead>
													<tbody>
														<tr *ngFor="let candidate of candidatesList">
															<td><span>{{candidate.firstName}}</span></td>
															<td><span>{{candidate.lastName}}</span></td>
															<td>
																<span>{{candidate.email}}</span>
															</td>
															<td>
																<span>{{candidate.phoneNumber}}</span>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
											<!-- Display message -->
											<div class="col-xs-12 mt-5" *ngIf="showCandidateUpdateFailureMessage">
												<div class="alert alert-danger" role="alert">
													The resume being uploaded matches another candidate (not the selected candidate) in the system.
													This resume
													cannot be uploaded for the selected candidate.
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
